module.exports = __webpack_public_path__ + "img/FO.37c238d6.svg";